import React from 'react';

const leaders = [
  {
    name: "Mr. Manish Kumar",
    role: "CEO/Founder",
    description:<p>A distinguished series entrepreneur, investor, and visionary, serving as the driving 
force behind several groundbreaking IT and IT-enabled companies. <br></br>
<b>Graduate from St. Stephen's College</b>,  Master’s in Computer Science from <b>Delhi University</b>, 
and an MBA from <b>FMS</b>.
Additionally, he has completed executive certification programmes from MIT and 
The Wharton School, further equipping me to lead Next-Gen digital initiatives. 
He is also associated with the Tie-Patna as Charter Member. 
A Certified Independent Director by IICA and serve as a founding member/CTO for several 
Next-Gen startups and global technology ventures.</p> ,
    image: "Manish_Kumar.png", // Replace with your image path
    type: "primary"
  },
  {
    name: "Mr. Abhishek Khandelwal",
    role: "CTO/Co-Founder",
    description: <p>A <b>technology-driven professional</b> focused on building <b>agile, high-performing teams</b> and unlocking the best in both people and software.<br></br>

<b>Technology-agnostic</b> and continuously exploring innovative ways to <b>enhance productivity and efficiency.</b>

Brings extensive experience in <b>modernizing and supporting front, middle, and back-office platforms,</b> aligned closely with business goals.<br></br>

Well-versed in <b>Java/J2EE, Spring, Cloud Computing, DevOps, and AI/ML,</b> with a strong focus on practical, value-driven implementation. </p>,
    image: "Abhishek_khandelwal.png", // Replace with your image path
    type: "secondary"
  }
];

const teamMembers = [
  { id: 1,
     name: "Ms. Nitu Vimal", 
     role: "HR & Talent Scout Head", 
     image: "Nitu-vimal.png" ,
     detail: "Nitu Vimal is a highly accomplished and dynamic HR & Talent Scout Head, holding a Master of Business Administration from Pune University, along with advanced certifications in SAP HR and AI Tools Workshop. She is widely recognized for building high-performing, people-centric organizations through strategic talent acquisition and robust HR frameworks. With a strong ethical foundation and a discerning eye for talent, she has successfully led recruitment transformations and enhanced employer branding initiatives. Her forward-looking approach seamlessly integrates human empathy with business strategy, leveraging technology and analytics to develop agile, future-ready workforces."
    },

  { id: 2,
    name: "Mr. Sunny",
      role: "Practice Head -  Data Scientist",
       image: "Sunny-singh.png",
      detail: "Data Science Consultant with 8 years of experience in the AI domain, specializing in Agentic AI and the development of autonomous decision-making systems."
     },
      

  { id: 3,
     name: "Mr. Upendra Singh",
      role: "Practice Lead - Development",
       image: "Upendra-singh.png" ,
      detail: "Experienced fintech technology leader with 16+ years in software development, specializing in robust and secure financial platforms."
  },
    { id: 4,
    name: "Mr. Kundan Singh",
      role: "Practice Head - Design",
       image: "Kundan-Kumar.jpeg" ,
      detail: "A creative design professional with expertise in UI/UX, visual storytelling, and user-centric design systems."
 },
 ,
    { id: 5,
    name: "Mrs. Somya Singh",
      role: "Practice Head - Quality Analyst",
       image: "Somya_Singh.jpeg" ,
      detail: "specializing in Healthcare GP Systems along with other enterprise projects. She owns end-to-end quality delivery including test planning, execution strategy, risk management, and release validation. Her experience includes working closely with product owners, developers, and clinical stakeholders to ensure safe, compliant, and user-friendly healthcare solutions. She is passionate about building strong QA practices and mentoring teams to achieve consistent delivery excellence."
 },
    { id: 6,
     name: "Dr. Rajasshrie Pillai", 
     role: "Principal AI Consultant",
      image: "Rajashree.png",
     detail:"Dr. Rajasshrie Pillai is a Professor of Management (IT/HRM) and Assistant Dean (Academics) at CIMP, with over 20 years of experience across industry, academia, and leadership. She is ranked among the Top 2% Global Researchers (Stanford–Elsevier) and is recognized for high-impact work in AI, Generative AI, and Digital Transformation. She has delivered 100+ training and executive programs and is widely respected for her academic leadership and human-centric technology expertise.",
  },
 { id: 7,
     name: "Dr. Kalyan Prasad Agrawal", 
     role: "Senior AI Consultant", 
     image: "Kalyan-prashad.jpeg" ,
     detail: "Kalyan Prasad Agrawal is a faculty member in Information Systems at the Chandragupt Institute of Management Patna (CIMP).He has rich experience in Artificial Intelligence, Business Analytics, and Technology Management, combining academic research with corporate training. He regularly conducts Executive Development Programs for working professionals and government executives. His key interests include AI, E-Governance, Social Innovation, Risk Management, and Smart Cities."
    }
    
];

const ourteam = () => {
  return (
    <section className="leadership-container" >
      <div className="header-text">
        <h2>Meet Our <br /><span>Visionary Leader</span></h2>
        <p className="sub-text">Behind every brilliant idea and smooth management, there's a team of creative minds working passionately!</p>
      </div>

      <div className="leaders-list">
        {leaders.map((leader, index) => (
          <div key={index} className={`leader-card ${leader.type}`}>
            <div className="image-wrapper">
              <img src={leader.image} alt={leader.name} />
              {/* <div className="border-accent"></div> */}
            </div>
            <div className="content-wrapper">
              {leader.type === 'secondary' && <span className="badge"><img src="ourteam-Icon.png"></img>LEADERSHIP EXCELLENCE</span>}
              <h3>{leader.name}</h3>
              <p className="role">{leader.role}</p>
              <p className="description">{leader.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div  className='team-member-maincontainer'>
        <div className='team-member-container'>
        <div className="team-header">
          <div className="title-area">
            <h2>Meet our Team</h2>
          </div>
          <div className="desc-area">
            <p>
              Meet the exceptional leaders who drive our vision forward with passion, 
              expertise, and unwavering commitment to excellence.
            </p>
          </div>
        </div>

        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="member-card"  >
              <div className="image-holder" data-detail={member.detail}>
                <img src={member.image} alt={member.name} />
                <div className="overlay-info">
                  <h4>{member.name}</h4>
                  <p>{member.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        </div>
      </div>
</section>
  );
};

export default ourteam;